import { IOffer } from '../../types/offers';

export const getAccessType = (offer: IOffer) => {
  const type = offer.accessType || (offer.building && offer.building.accessType);

  if (!offer.category || !offer.category.startsWith('office')) {
    return undefined;
  }

  switch (type) {
    case 'free':
      return 'свободный вход';
    case 'passSystem':
      return 'вход по пропускам';
    default:
      return undefined;
  }
};
